import styled from 'styled-components';

export default styled.div`
  background: #1a1d35;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 1.5em;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }

  .order--header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 1.25em;
    padding-bottom: 1em;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    .tracking--info {
      display: flex;
      align-items: center;
      gap: 0.75em;

      .box-icon {
        font-size: 1.5rem;
        color: ${({ theme }) => theme.primary};
      }

      .tracking--number {
        font-size: 1.1rem;
        font-weight: 600;
        color: #fff;
        margin: 0 0 0.25em 0;
      }

      .customer--name {
        display: flex;
        align-items: center;
        gap: 0.5em;
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.6);
        margin: 0;

        .small-icon {
          font-size: 0.75rem;
        }
      }
    }

    .status--badge {
      padding: 0.4em 0.8em;
      border-radius: 6px;
      font-size: 0.75rem;
      font-weight: 600;
      color: #fff;
      white-space: nowrap;
    }
  }

  .order--details {
    display: flex;
    flex-direction: column;
    gap: 0.75em;
    margin-bottom: 1em;

    .detail--row {
      display: flex;
      align-items: flex-start;
      gap: 0.75em;

      .icon {
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.5);
        margin-top: 0.15em;
        flex-shrink: 0;

        &.pickup {
          color: #4CAF50;
        }

        &.delivery {
          color: #2196F3;
        }
      }

      .detail--content {
        display: flex;
        flex-direction: column;
        gap: 0.25em;
        flex: 1;
        min-width: 0;

        .label {
          font-size: 0.75rem;
          color: rgba(255, 255, 255, 0.5);
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .value {
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.9);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .order--footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 1em;
    border-top: 1px solid rgba(255, 255, 255, 0.05);

    .price--info {
      display: flex;
      flex-direction: column;
      gap: 0.25em;

      .price--label {
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.5);
        text-transform: uppercase;
      }

      .price--value {
        font-size: 1.25rem;
        font-weight: 700;
        color: ${({ theme }) => theme.primary};
      }
    }

    .payment--status {
      padding: 0.4em 0.8em;
      border-radius: 6px;
      font-size: 0.75rem;
      font-weight: 600;

      &.paid {
        background: rgba(76, 175, 80, 0.15);
        color: #4CAF50;
      }

      &.unpaid {
        background: rgba(255, 152, 0, 0.15);
        color: #FF9800;
      }
    }
  }
`;
